export default __webpack_public_path__ + "static/media/womenTshirt.425f4836.svg";